"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateLanguageDto = instanceOfUpdateLanguageDto;
exports.UpdateLanguageDtoFromJSON = UpdateLanguageDtoFromJSON;
exports.UpdateLanguageDtoFromJSONTyped = UpdateLanguageDtoFromJSONTyped;
exports.UpdateLanguageDtoToJSON = UpdateLanguageDtoToJSON;
exports.UpdateLanguageDtoToJSONTyped = UpdateLanguageDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateLanguageDto interface.
 */
function instanceOfUpdateLanguageDto(value) {
    if (!('languageId' in value) || value['languageId'] === undefined)
        return false;
    return true;
}
function UpdateLanguageDtoFromJSON(json) {
    return UpdateLanguageDtoFromJSONTyped(json, false);
}
function UpdateLanguageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'languageId': json['languageId'],
    };
}
function UpdateLanguageDtoToJSON(json) {
    return UpdateLanguageDtoToJSONTyped(json, false);
}
function UpdateLanguageDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'languageId': value['languageId'],
    };
}
